import { useState } from "react";
import { useListContext, useTranslate } from "ra-core";
import { RadioTower } from "lucide-react";

import { Button } from "@/components/ui/button";

import type { Contact } from "../types";
import { WhatsAppBroadcastDialog } from "../whatsapp/WhatsAppBroadcastDialog";
import { extractCohortFilter, useCohortFiltersEnabled } from "./cohortFilters";

/**
 * Lives in the contact-list toolbar. When cohort filters are active it offers a
 * "Broadcast to this segment" action that opens the composer in cohort mode,
 * passing the active filter as `contact_filter` (no IDs materialized). Hidden
 * when the backend lacks cohort support or no cohort dimension is selected.
 */
export function SegmentBroadcastButton() {
  const translate = useTranslate();
  const cohortEnabled = useCohortFiltersEnabled();
  const { filterValues } = useListContext<Contact>();
  const [open, setOpen] = useState(false);

  const cohortFilter = extractCohortFilter(filterValues);
  if (!cohortEnabled || !cohortFilter) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-9"
        onClick={() => setOpen(true)}
      >
        <RadioTower className="size-4" />
        {translate("crm.whatsapp.broadcasts.cohort.broadcast_to_segment")}
      </Button>
      <WhatsAppBroadcastDialog
        open={open}
        contactFilter={cohortFilter}
        onOpenChange={setOpen}
      />
    </>
  );
}
